import { tableHooks } from './duck';

const { useServerSidePaginationAndSorting } = tableHooks;
export { default as Table } from './Table';
export * from './components';
export { tableTypes, tableMocks } from './duck';
export { useServerSidePaginationAndSorting };
